<template>
  <ui-card name="trip.details" :error="error" rounded>
    <div class="root">
      <section class="summary">
        <stats-collection :items="stats" />
        <div class="types">
          <h3>{{ $t(`trip.details.road_type`) }}</h3>
          <ul>
            <li v-for="(type, index) in roadTypes" :key="index">
              {{ $t(`trip.road_types.${type}`) }}
            </li>
          </ul>
        </div>
      </section>
      <section class="scores">
        <score-collection :values="scores" />
      </section>
    </div>
  </ui-card>
</template>

<script>
import * as moment from 'moment';
import { mstohm } from 'utils/time';
import { groupBy } from 'lodash';
import { driving } from 'config/settings';
import { mapGetters } from 'vuex';
import StatsCollection from 'views/elements/stats/StatsCollection';
import ScoreCollection from 'views/charts/ScoreCollection';

export default {
  components: {
    StatsCollection,
    ScoreCollection,
  },

  computed: {
    ...mapGetters('trip', ['waypoints']),

    user() {
      return this.$store.state.user;
    },

    trip() {
      return this.$store.state.trip;
    },

    error() {
      if (this.roadTypes.length === 0) {
        return 'missing_data';
      }
      if (!this.scores) {
        return 'learning';
      }
      return '';
    },

    roadTypes() {
      let waypoints = this.waypoints.filter(waypoint => !!waypoint.road_type);
      let groups = groupBy(waypoints, 'road_type');
      return Object.keys(groups);
    },

    stats() {
      const trip = this.trip;
      const distance = (trip.distance / 1000).toFixed(1);
      const start = moment.parseZone(trip.start).format('h:mm a');
      const end = moment.parseZone(trip.end).format('h:mm a');
      const duration = mstohm(trip.end_ts - trip.start_ts);

      return [
        { label: this.$t('trip.details.start'), value: start },
        { label: this.$t('trip.details.end'), value: end },
        {
          label: this.$t('trip.details.distance'),
          value: this.$t('ui.values.km', [distance]),
        },
        { label: this.$t('trip.details.duration'), value: duration },
      ];
    },

    scores() {
      const trip = this.trip;
      if (trip.behavior_scores) {
        return driving.types.map(type => {
          return {
            label: `trip.driving_behavior.${type}`,
            tooltip: `trip.driving_behavior_tooltip.${type}`,
            value: trip.behavior_scores[type] * 100,
          };
        });
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.root,
section {
  display: flex;
  flex: 1;
  flex-basis: auto;
}

section {
  flex-direction: column;
}

.summary {
  flex: 1 1 50%;
  border-right: 1px solid #e0e0e0;
}

.scores {
  flex: 1 1 50%;
  max-width: 400px;
}

.types {
  padding: 1rem;

  li {
    display: inline-block;
    padding: 1px 6px;
    margin-right: 3px;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    opacity: 0.87;
    font-size: 0.875rem;
  }
}

h3 {
  margin-bottom: 1rem;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  color: #000000;
  opacity: 0.72;
}

.card-header-link {
  top: -2px;
}
</style>
